unit LoginRequest;
{

/* Initial. */

}
interface

uses
  BaseRequest;

type
  TLoginRequest = class(TBaseRequest)
  private
    fLoginName: String;
    fPassword: String;
  public
    constructor Create(const String_LoginKey: String; const String_LoginName: String; const String_Password: String);
    function ToJSON: String; override;
  end;

implementation

constructor TLoginRequest.Create(const String_LoginKey: String; const String_LoginName: String; const String_Password: String);
begin
  inherited Create(String_LoginKey);

  fLoginName := String_LoginName;
  fPassword := String_Password;
end;

function TLoginRequest.ToJSON: String;
begin
  Result := '{"loginKey":"' + LoginKey + '","loginName":"' + fLoginName + '","password":"' + fPassword + '"}';
end;

end.
